import { Box, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { EventLocation, trackClickedToView, useL10n } from '@uplift/hooks';
import { Alert, Button, useScrollableView } from '@uplift/ui-v2';
import { ProviderCard } from './provider-card';
import { usePsychiatryMatchingContext } from './psychiatry-matching-context';
import { useStyles } from './styles';
import { MatchingProvidersType } from '@uplift/api';

export const ConnectStep: React.VFC = () => {
  const l10n = useL10n();
  const { scrollTo } = useScrollableView();
  const { state, dispatch } = usePsychiatryMatchingContext();
  const { classes } = useStyles({ isDrawer: state.isDrawer });

  const handleProfileSelect = (providerId: string, selectedProfileName: string) => {
    if (state?.isDrawer) {
      trackClickedToView({
        location: EventLocation.videoSession,
        providerName: selectedProfileName
      });
    }
    dispatch({
      type: 'viewProviderProfile',
      payload: providerId
    });

    /**
       * Scroll to top of the page when a provider is selected
       * so that user doesnt land in middle of the provider profile
       */
    scrollTo({ top: 0, behavior: 'instant' });
  };

  const handleBack = () => {
    dispatch({
      type: 'changeStep',
      payload: 'start'
    });
  };

  return (
    <>
      {state?.isDrawer && (
        <Box p={1}>
          <Button startIcon={<ArrowBack fontSize="inherit" />} type="button" color="secondary" size="small" onClick={handleBack} className={classes.backButton}>
            {l10n.navigation.back}
          </Button>
        </Box>
      )}
      <Box className={classes.halfWidth} paddingTop={state.isDrawer ? '8px' : ''}>
        <Typography variant={state.isDrawer ? 'h4' : 'h2'}>
          {l10n.psychiatry.connect(state?.patientName)}
        </Typography>
        {state.matchingProvidersType === MatchingProvidersType.insurance ? (
          <Box mt={3} mb={6} className={classes.acceptsBlock}>
            All providers <span className={classes.accepts}>accept</span> {state.patientName}'s insurance
          </Box>
        ) : (
          <Box mt={3} mb={5}>
            <Alert severity="info" showIcon={false}>{l10n.psychiatry.doesNotHaveInsurance(state.patientName)}</Alert>
          </Box>
        )}
        {state.providers.map(item => (
          <Box mb={3} key={item.user.id}>
            <ProviderCard
              provider={item}
              onProfileSelect={handleProfileSelect}
            />
          </Box>
        ))}
      </Box>
    </>
  );
};
